
<template>
  <div
    class="settings-sidebar"
    :class="{ 'dark-theme': isDarkTheme }"
  >
    <!-- =====================================================
         HEADER
    ====================================================== -->

    <div class="header">

      <div class="header-content">
        <span class="header-eyebrow">
          ИНФОРМАЦИЯ
        </span>

        <h2 class="title">
          Диалог
        </h2>

        <p class="header-description">
          Детали переписки
        </p>
      </div>

      <!-- ACTION MENU -->

      <div
        ref="menuRef"
        class="menu-wrapper"
      >
        <button
          ref="menuButtonRef"
          type="button"
          class="menu-button"
          :class="{ active: dropdownVisible }"
          title="Действия с диалогом"
          aria-label="Действия с диалогом"
          aria-haspopup="menu"
          :aria-expanded="dropdownVisible"
          @click.stop="toggleDropdown"
        >
          <svg viewBox="0 0 24 24" fill="none">
            <circle
              cx="5"
              cy="12"
              r="1.8"
              fill="currentColor"
            />
            <circle
              cx="12"
              cy="12"
              r="1.8"
              fill="currentColor"
            />
            <circle
              cx="19"
              cy="12"
              r="1.8"
              fill="currentColor"
            />
          </svg>
        </button>

        <Transition name="dropdown">
          <div
            v-if="dropdownVisible"
            class="dropdown"
            role="menu"
          >
            <button
              type="button"
              class="dropdown-item danger"
              role="menuitem"
              @click="handleDeleteChat"
            >
              <span class="dropdown-item-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <path
                    d="M4 7H20M9 7V4H15V7M6.5 7L7.5 20H16.5L17.5 7"
                    stroke="currentColor"
                    stroke-width="1.7"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10 11V16M14 11V16"
                    stroke="currentColor"
                    stroke-width="1.7"
                    stroke-linecap="round"
                  />
                </svg>
              </span>

              <span>Удалить чат</span>
            </button>
          </div>
        </Transition>
      </div>
    </div>

    <!-- =====================================================
         SEPARATOR
    ====================================================== -->

    <div class="separator"></div>

    <!-- =====================================================
         VACANCY SECTION
    ====================================================== -->

    <section class="section">

      <div class="section-header">

        <div class="section-icon">
          <svg viewBox="0 0 24 24" fill="none">
            <rect
              x="3.5"
              y="7"
              width="17"
              height="13"
              rx="2.5"
              stroke="currentColor"
              stroke-width="1.7"
            />
            <path
              d="M8.5 7V5.5C8.5 4.4 9.4 3.5 10.5 3.5H13.5C14.6 3.5 15.5 4.4 15.5 5.5V7"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            />
            <path
              d="M3.5 12.5C8.5 15.2 15.5 15.2 20.5 12.5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </div>

        <div class="section-heading">
          <h3 class="subtitle">
            Отклик на вакансию
          </h3>

          <p class="section-description">
            Связанная с диалогом вакансия
          </p>
        </div>

      </div>

      <!-- LOADING -->

      <div
        v-if="isLoading"
        class="vacancy-loading"
        aria-label="Загрузка вакансии"
        aria-busy="true"
      >
        <div class="skeleton-card">

          <div class="skeleton-header">
            <div class="skeleton-icon shimmer"></div>

            <div class="skeleton-lines">
              <div class="skeleton-line long shimmer"></div>
              <div class="skeleton-line short shimmer"></div>
            </div>
          </div>

          <div class="skeleton-line full shimmer"></div>
          <div class="skeleton-line medium shimmer"></div>

          <div class="skeleton-footer">
            <div class="skeleton-pill shimmer"></div>
            <div class="skeleton-pill small shimmer"></div>
          </div>

        </div>
      </div>

      <!-- VACANCY -->

      <div
        v-else-if="vacancy"
        class="vacancy-container"
      >
        <div class="vacancy-label">
          <span class="vacancy-label-dot"></span>

          Отклик на вакансию
        </div>

        <VacancyItem :vacancy="vacancy" />
      </div>

      <!-- EMPTY STATE -->

      <div
        v-else
        class="empty-vacancy"
      >
        <div class="empty-icon">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M4 8.5C4 7.1 5.1 6 6.5 6H17.5C18.9 6 20 7.1 20 8.5V16C20 17.4 18.9 18.5 17.5 18.5H6.5C5.1 18.5 4 17.4 4 16V8.5Z"
              stroke="currentColor"
              stroke-width="1.6"
            />
            <path
              d="M8.5 6V5C8.5 3.9 9.4 3 10.5 3H13.5C14.6 3 15.5 3.9 15.5 5V6"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
            <path
              d="M9 12.5H15"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
          </svg>
        </div>

        <h4 class="empty-title">
          Без отклика
        </h4>

        <p class="empty-text">
          Этот диалог не связан с откликом на вакансию
        </p>
      </div>

    </section>

    <!-- =====================================================
         FOOTER
    ====================================================== -->

    <div class="sidebar-footer">
      <div class="footer-info">
        <svg viewBox="0 0 24 24" fill="none">
          <circle
            cx="12"
            cy="12"
            r="9"
            stroke="currentColor"
            stroke-width="1.6"
          />
          <path
            d="M12 11V16M12 8H12.01"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
          />
        </svg>

        <span>
          Управление диалогом
        </span>
      </div>
    </div>

    <!-- =====================================================
         DELETE CONFIRMATION
    ====================================================== -->

    <Transition name="modal">
      <div
        v-if="confirmVisible"
        class="modal-overlay"
        @click.self="closeConfirmation"
      >
        <div
          class="modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="delete-chat-title"
          aria-describedby="delete-chat-description"
        >
          <div class="modal-icon-wrapper">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M4 7H20M9 7V4H15V7M6.5 7L7.5 20H16.5L17.5 7"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10 11V16M14 11V16"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
              />
            </svg>
          </div>

          <h3
            id="delete-chat-title"
            class="modal-title"
          >
            Удалить чат?
          </h3>

          <p
            id="delete-chat-description"
            class="modal-text"
          >
            Вы действительно хотите удалить этот диалог?
            Это действие необратимо.
          </p>

          <div class="modal-buttons">
            <button
              ref="cancelButtonRef"
              type="button"
              class="cancel-btn"
              @click="closeConfirmation"
            >
              Отмена
            </button>

            <button
              type="button"
              class="delete-btn"
              @click="confirmDelete"
            >
              Удалить
            </button>
          </div>

        </div>
      </div>
    </Transition>

    <!-- RIGHT BORDER -->

    <div class="vertical-separator"></div>

  </div>
</template>

<script setup>
import {
  ref,
  watch,
  nextTick,
  onMounted,
  onBeforeUnmount
} from "vue";

import ChatsService from "../../api/ChatsService";
import VacancyItem from "../VacancyItem.vue";

// ============================================================
// PROPS
// ============================================================

const props = defineProps({
  userId: {
    type: String,
    default: ""
  },

  interlocutorId: {
    type: String,
    default: ""
  }
});

// ============================================================
// EMITS
// ============================================================

const emit = defineEmits(["deleteChat"]);

// ============================================================
// STATE
// ============================================================

const dropdownVisible = ref(false);
const confirmVisible = ref(false);

const vacancy = ref(null);
const isLoading = ref(true);

const menuRef = ref(null);
const menuButtonRef = ref(null);
const cancelButtonRef = ref(null);

// ============================================================
// LOCAL THEME
// ============================================================

const isDarkTheme = ref(false);

let themeObserver = null;

function updateTheme() {
  isDarkTheme.value =
    document.documentElement.getAttribute("data-theme") === "dark";
}

// ============================================================
// VACANCY LOADING
// ============================================================

let vacancyRequestId = 0;

async function loadVacancy() {
  const requestId = ++vacancyRequestId;

  isLoading.value = true;
  vacancy.value = null;

  if (!props.userId || !props.interlocutorId) {
    isLoading.value = false;
    return;
  }

  try {
    const response =
      await ChatsService.getVacanciesRespondedByInterlocutor(
        props.userId,
        props.interlocutorId
      );

    if (requestId !== vacancyRequestId) {
      return;
    }

    vacancy.value =
      Array.isArray(response) && response.length > 0
        ? response[0]
        : null;

  } catch (error) {
    if (requestId !== vacancyRequestId) {
      return;
    }

    console.error(
      "❌ Ошибка загрузки откликов:",
      error
    );

    vacancy.value = null;

  } finally {
    if (requestId === vacancyRequestId) {
      isLoading.value = false;
    }
  }
}

// Перезагружаем данные, если сменился собеседник

watch(
  () => [props.userId, props.interlocutorId],
  loadVacancy,
  { immediate: true }
);

// ============================================================
// DROPDOWN
// ============================================================

function toggleDropdown() {
  dropdownVisible.value = !dropdownVisible.value;
}

function closeDropdown() {
  dropdownVisible.value = false;
}

function handleOutsideClick(event) {
  if (!dropdownVisible.value) {
    return;
  }

  if (
    menuRef.value &&
    !menuRef.value.contains(event.target)
  ) {
    closeDropdown();
  }
}

// ============================================================
// DELETE CHAT
// ============================================================

async function handleDeleteChat() {
  closeDropdown();

  confirmVisible.value = true;

  await nextTick();
  cancelButtonRef.value?.focus();
}

function closeConfirmation() {
  confirmVisible.value = false;

  nextTick(() => {
    menuButtonRef.value?.focus();
  });
}

function confirmDelete() {
  confirmVisible.value = false;

  emit("deleteChat");
}

// ============================================================
// KEYBOARD
// ============================================================

function handleKeydown(event) {
  if (event.key !== "Escape") {
    return;
  }

  if (confirmVisible.value) {
    closeConfirmation();
    return;
  }

  closeDropdown();
}

// ============================================================
// LIFECYCLE
// ============================================================

onMounted(() => {
  updateTheme();

  themeObserver = new MutationObserver(updateTheme);

  themeObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-theme"]
  });

  document.addEventListener(
    "pointerdown",
    handleOutsideClick
  );

  document.addEventListener(
    "keydown",
    handleKeydown
  );
});

onBeforeUnmount(() => {
  vacancyRequestId++;

  themeObserver?.disconnect();
  themeObserver = null;

  document.removeEventListener(
    "pointerdown",
    handleOutsideClick
  );

  document.removeEventListener(
    "keydown",
    handleKeydown
  );
});
</script>

<style scoped>

/* ============================================================
   SIDEBAR — LIGHT THEME
============================================================ */

.settings-sidebar {
  --settings-bg: #ffffff;
  --settings-text: #222b38;
  --settings-secondary: #8993a2;
  --settings-muted: #a4adba;

  --settings-border: rgba(31, 55, 90, 0.075);

  --settings-accent: #2173e5;
  --settings-accent-soft: rgba(33, 115, 229, 0.075);

  --settings-surface: #f6f8fb;
  --settings-surface-hover: #eef3fa;

  --settings-menu-bg: #ffffff;

  --settings-danger: #e45454;
  --settings-danger-soft: rgba(235, 87, 87, 0.09);

  --settings-skeleton-a: #edf0f5;
  --settings-skeleton-b: #f7f9fc;

  position: relative;

  display: flex;
  flex-direction: column;

  width: 300px;
  height: 100%;

  padding: 24px;

  background: var(--settings-bg);

  font-family: "Eastman-Regular", sans-serif;

  color: var(--settings-text);

  /* Keep original content-box sizing */
  box-sizing: content-box;
}

/* ============================================================
   DARK THEME — LOCAL CLASS
============================================================ */

.settings-sidebar.dark-theme {
  --settings-bg: #161616;
  --settings-text: #f1f2f4;
  --settings-secondary: #a0a6ae;
  --settings-muted: #777e89;

  --settings-border: rgba(255, 255, 255, 0.075);

  --settings-accent: #83b6ff;
  --settings-accent-soft: rgba(111, 168, 255, 0.11);

  --settings-surface: #242424;
  --settings-surface-hover: #2c2c2c;

  --settings-menu-bg: #202020;

  --settings-danger: #ff7979;
  --settings-danger-soft: rgba(235, 87, 87, 0.12);

  --settings-skeleton-a: #292929;
  --settings-skeleton-b: #393939;
}

/* ============================================================
   HEADER
============================================================ */

.header {
  position: relative;
  z-index: 20;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  gap: 16px;
}

.header-content {
  display: flex;
  flex-direction: column;

  gap: 7px;

  min-width: 0;
}

.header-eyebrow {
  font-family: "Eastman-Medium", sans-serif;

  font-size: 9px;
  font-weight: 500;

  letter-spacing: 1.4px;

  color: var(--settings-accent);
}

.title {
  margin: 0;

  font-family: "Eastman-Bold", sans-serif;
  font-size: 23px;
  font-weight: 700;

  line-height: 1.15;

  letter-spacing: -0.6px;

  color: var(--settings-text);
}

.header-description {
  margin: 0;

  font-family: "Eastman-Regular", sans-serif;
  font-size: 11px;

  color: var(--settings-secondary);
}

/* ============================================================
   MENU
============================================================ */

.menu-wrapper {
  position: relative;

  flex-shrink: 0;
}

.menu-button {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 35px;
  height: 35px;

  padding: 0;

  border: 1px solid var(--settings-border);
  border-radius: 11px;

  background: var(--settings-surface);

  color: var(--settings-secondary);

  cursor: pointer;

  transition:
    background 0.18s ease,
    color 0.18s ease,
    border-color 0.18s ease;
}

.menu-button svg {
  width: 19px;
  height: 19px;
}

.menu-button:hover,
.menu-button.active {
  background: var(--settings-accent-soft);

  color: var(--settings-accent);

  border-color: rgba(33, 115, 229, 0.15);
}

.menu-button:focus-visible {
  outline: 2px solid var(--settings-accent);
  outline-offset: 3px;
}

/* ============================================================
   DROPDOWN
============================================================ */

.dropdown {
  position: absolute;

  top: 43px;
  right: 0;

  z-index: 100;

  width: 177px;

  padding: 6px;

  background: var(--settings-menu-bg);

  border: 1px solid var(--settings-border);
  border-radius: 13px;

  box-shadow:
    0 14px 35px rgba(24, 38, 60, 0.13),
    0 2px 7px rgba(24, 38, 60, 0.035);

  box-sizing: border-box;
}

.settings-sidebar.dark-theme .dropdown {
  box-shadow:
    0 18px 40px rgba(0, 0, 0, 0.4);
}

.dropdown-item {
  display: flex;
  align-items: center;

  gap: 10px;

  width: 100%;
  min-height: 39px;

  padding: 9px 10px;

  border: none;
  border-radius: 9px;

  background: transparent;

  color: var(--settings-text);

  font-family: "Eastman-Medium", sans-serif;
  font-size: 11px;

  text-align: left;

  cursor: pointer;

  transition: background 0.16s ease;
}

.dropdown-item.danger {
  color: var(--settings-danger);
}

.dropdown-item.danger:hover {
  background: var(--settings-danger-soft);
}

.dropdown-item:focus-visible {
  outline: 2px solid var(--settings-danger);
  outline-offset: -2px;
}

.dropdown-item-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 20px;
  height: 20px;

  flex-shrink: 0;
}

.dropdown-item-icon svg {
  width: 19px;
  height: 19px;
}

/* ============================================================
   SEPARATOR
============================================================ */

.separator {
  width: 100%;
  height: 1px;

  flex-shrink: 0;

  margin: 23px 0 25px;

  background: var(--settings-border);
}

/* ============================================================
   VACANCY SECTION
============================================================ */

.section {
  min-width: 0;
  flex: 1;

  display: flex;
  flex-direction: column;

  gap: 19px;
}

/* ============================================================
   SECTION HEADER
============================================================ */

.section-header {
  display: flex;
  align-items: flex-start;

  gap: 11px;
}

.section-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 38px;
  height: 38px;

  flex-shrink: 0;

  border: 1px solid rgba(33, 115, 229, 0.06);
  border-radius: 12px;

  background: var(--settings-accent-soft);

  color: var(--settings-accent);
}

.section-icon svg {
  width: 20px;
  height: 20px;
}

.section-heading {
  display: flex;
  flex-direction: column;

  gap: 5px;

  min-width: 0;

  padding-top: 2px;
}

.subtitle {
  margin: 0;

  font-family: "Eastman-Bold", sans-serif;
  font-size: 13px;

  line-height: 1.35;

  color: var(--settings-text);
}

.section-description {
  margin: 0;

  font-family: "Eastman-Regular", sans-serif;
  font-size: 10px;

  line-height: 1.4;

  color: var(--settings-secondary);
}

/* ============================================================
   VACANCY CONTENT
============================================================ */

.vacancy-container {
  display: flex;
  flex-direction: column;

  gap: 12px;

  min-width: 0;
  width: 100%;
}

.vacancy-label {
  display: inline-flex;
  align-items: center;

  align-self: flex-start;

  gap: 7px;

  padding: 6px 10px;

  border: 1px solid rgba(39, 183, 130, 0.12);
  border-radius: 8px;

  background: rgba(39, 183, 130, 0.07);

  font-family: "Eastman-Medium", sans-serif;
  font-size: 10px;

  color: #218c59;
}

.settings-sidebar.dark-theme .vacancy-label {
  color: #6bd3a4;

  background: rgba(39, 183, 130, 0.12);
  border-color: rgba(39, 183, 130, 0.15);
}

.vacancy-label-dot {
  width: 6px;
  height: 6px;

  flex-shrink: 0;

  border-radius: 50%;

  background: currentColor;
}

/* ============================================================
   EMPTY STATE
============================================================ */

.empty-vacancy {
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 9px;

  width: 100%;

  padding: 31px 20px;

  border: 1px dashed var(--settings-border);
  border-radius: 17px;

  background: var(--settings-surface);

  box-sizing: border-box;

  text-align: center;
}

.empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 52px;
  height: 52px;

  margin-bottom: 6px;

  border-radius: 16px;

  background: var(--settings-accent-soft);

  color: var(--settings-accent);
}

.empty-icon svg {
  width: 25px;
  height: 25px;
}

.empty-title {
  margin: 0;

  font-family: "Eastman-Bold", sans-serif;
  font-size: 13px;

  color: var(--settings-text);
}

.empty-text {
  max-width: 215px;

  margin: 0;

  font-family: "Eastman-Regular", sans-serif;
  font-size: 11px;
  line-height: 1.55;

  color: var(--settings-secondary);
}

/* ============================================================
   SKELETON
============================================================ */

.vacancy-loading {
  width: 100%;
}

.skeleton-card {
  display: flex;
  flex-direction: column;

  gap: 17px;

  width: 100%;
  min-height: 150px;

  padding: 16px;

  border: 1px solid var(--settings-border);
  border-radius: 17px;

  background: var(--settings-surface);

  box-sizing: border-box;
}

.skeleton-header {
  display: flex;
  align-items: center;

  gap: 11px;
}

.skeleton-icon {
  width: 43px;
  height: 43px;

  flex-shrink: 0;

  border-radius: 12px;
}

.skeleton-lines {
  display: flex;
  flex: 1;
  flex-direction: column;

  gap: 9px;
}

.skeleton-line {
  height: 9px;

  border-radius: 5px;
}

.skeleton-line.long {
  width: 80%;
  height: 11px;
}

.skeleton-line.short {
  width: 48%;
}

.skeleton-line.full {
  width: 92%;
}

.skeleton-line.medium {
  width: 67%;
}

.skeleton-footer {
  display: flex;
  align-items: center;

  gap: 8px;
}

.skeleton-pill {
  width: 95px;
  height: 19px;

  border-radius: 7px;
}

.skeleton-pill.small {
  width: 61px;
}

.shimmer {
  background: linear-gradient(
    110deg,
    var(--settings-skeleton-a) 8%,
    var(--settings-skeleton-b) 18%,
    var(--settings-skeleton-a) 33%
  );

  background-size: 220% 100%;

  animation: shimmer 1.6s linear infinite;
}

/* ============================================================
   FOOTER
============================================================ */

.sidebar-footer {
  margin-top: auto;
  padding-top: 20px;
}

.footer-info {
  display: flex;
  align-items: center;

  gap: 7px;

  padding-top: 14px;

  border-top: 1px solid var(--settings-border);

  color: var(--settings-muted);

  font-family: "Eastman-Regular", sans-serif;
  font-size: 10px;
}

.footer-info svg {
  width: 15px;
  height: 15px;

  flex-shrink: 0;
}

/* ============================================================
   MODAL OVERLAY
============================================================ */

.modal-overlay {
  position: fixed;
  inset: 0;

  z-index: 2000;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 20px;

  background: rgba(12, 18, 28, 0.36);

  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);

  box-sizing: border-box;
}

.settings-sidebar.dark-theme .modal-overlay {
  background: rgba(0, 0, 0, 0.66);
}

/* ============================================================
   MODAL
============================================================ */

.modal {
  width: 360px;
  max-width: 100%;

  padding: 27px 25px 24px;

  background: var(--settings-bg);

  border: 1px solid var(--settings-border);
  border-radius: 20px;

  box-shadow:
    0 22px 65px rgba(0, 0, 0, 0.16);

  box-sizing: border-box;

  text-align: center;
}

.settings-sidebar.dark-theme .modal {
  box-shadow:
    0 25px 75px rgba(0, 0, 0, 0.48);
}

/* ============================================================
   MODAL ICON
============================================================ */

.modal-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 58px;
  height: 58px;

  margin: 0 auto 17px;

  border: 1px solid rgba(235, 87, 87, 0.1);
  border-radius: 18px;

  background: var(--settings-danger-soft);

  color: var(--settings-danger);
}

.modal-icon-wrapper svg {
  width: 27px;
  height: 27px;
}

/* ============================================================
   MODAL TEXT
============================================================ */

.modal-title {
  margin: 0;

  font-family: "Eastman-Bold", sans-serif;
  font-size: 18px;

  line-height: 1.3;

  color: var(--settings-text);
}

.modal-text {
  max-width: 285px;

  margin: 12px auto 23px;

  font-family: "Eastman-Regular", sans-serif;
  font-size: 12px;
  line-height: 1.65;

  color: var(--settings-secondary);
}

/* ============================================================
   MODAL BUTTONS
============================================================ */

.modal-buttons {
  display: flex;
  align-items: center;

  gap: 11px;
}

.cancel-btn,
.delete-btn {
  flex: 1;

  min-height: 42px;

  padding: 10px 12px;

  border: none;
  border-radius: 11px;

  font-family: "Eastman-Medium", sans-serif;
  font-size: 12px;

  cursor: pointer;

  transition:
    background 0.18s ease,
    opacity 0.18s ease,
    transform 0.18s ease;
}

.cancel-btn {
  background: var(--settings-surface);

  color: var(--settings-text);
}

.cancel-btn:hover {
  background: var(--settings-surface-hover);
}

.delete-btn {
  background: #eb5757;

  color: #ffffff;
}

.delete-btn:hover {
  background: #d94444;
}

.cancel-btn:active,
.delete-btn:active {
  transform: scale(0.97);
}

.cancel-btn:focus-visible,
.delete-btn:focus-visible {
  outline: 2px solid var(--settings-accent);
  outline-offset: 3px;
}

/* ============================================================
   VERTICAL SEPARATOR
============================================================ */

.vertical-separator {
  position: absolute;

  top: 0;
  right: 0;

  width: 1px;
  height: 100%;

  background: var(--settings-border);

  pointer-events: none;
}

/* ============================================================
   ANIMATIONS
============================================================ */

@keyframes shimmer {
  to {
    background-position-x: -220%;
  }
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition:
    opacity 0.16s ease,
    transform 0.16s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;

  transform: translateY(-6px) scale(0.97);
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.22s ease;
}

.modal-enter-active .modal,
.modal-leave-active .modal {
  transition:
    transform 0.22s ease,
    opacity 0.22s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal {
  transform: translateY(13px) scale(0.95);
}

.modal-leave-to .modal {
  transform: translateY(5px) scale(0.97);
}

/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 430px) {

  .settings-sidebar {
    position: fixed;

    left: 0;
    bottom: 0;

    z-index: 1000;

    width: 100%;
    height: auto;

    max-height: 85vh;
    overflow-y: auto;

    padding: 22px 19px 25px;

    border-radius: 24px 24px 0 0;

    box-sizing: border-box;

    box-shadow:
      0 -12px 38px rgba(0, 0, 0, 0.08);

    animation: slideUp 0.25s ease;
  }

  .settings-sidebar.dark-theme {
    box-shadow:
      0 -12px 38px rgba(0, 0, 0, 0.35);
  }

  .title {
    font-size: 21px;
  }

  .separator {
    margin: 21px 0 23px;
  }

  .section {
    flex: initial;
  }

  .sidebar-footer {
    margin-top: 24px;
  }

  .vertical-separator {
    display: none;
  }

  .modal-overlay {
    padding: 16px;
  }

  .modal {
    width: 100%;
    max-width: 360px;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ============================================================
   REDUCED MOTION
============================================================ */

@media (prefers-reduced-motion: reduce) {

  .shimmer {
    animation: none;
  }

  .menu-button,
  .dropdown-item,
  .cancel-btn,
  .delete-btn,
  .dropdown-enter-active,
  .dropdown-leave-active,
  .modal-enter-active,
  .modal-leave-active,
  .modal-enter-active .modal,
  .modal-leave-active .modal {
    transition: none;
  }

  .settings-sidebar {
    animation: none;
  }
}

</style>
